import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $submitting?: boolean;
  $customStyles?: any;
}

export const InputWrap = styled(Box)<CustomProps>`
  display: flex;
  flex-direction: column;
  position:relative;    
  width: ${props => props?.$customStyles?.$width || "250px"};
  max-width: ${props => props?.$customStyles?.$width || "250px"};
  max-width: 100%;
  ${(props) => props.$customStyles}
  input{    
    height: 36px;
    min-height:36px;
    border-radius: 6px;
    padding-left: 40px;
    padding-right: 10px;   
    width: 100%;
    border: 1px solid #EBEBEB;
    color: ${theme.colors.black};
    font-size: 14px;
    font-family:"Poppins";
  }  
`;

export const InputInner = styled.div`
  position:relative;   
`;

export const SearchIconWrap = styled.div`
  position:absolute;
  top:50%;
  left:15px;
  transform:translateY(-50%);
`